<h2 mat-dialog-title class="flex items-center justify-between">
  <span>{{ document.document_name }}</span>
  <button mat-icon-button (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<mat-dialog-content>
  <div *ngIf="loading" class="flex items-center justify-center py-20">
    <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
  </div>

  <div *ngIf="!loading" class="space-y-4">
    <!-- Document Info -->
    <div class="grid grid-cols-2 gap-4 p-4 bg-gray-50 rounded-md">
      <div>
        <p class="text-sm text-gray-500">File Size</p>
        <p class="font-medium">{{ formatFileSize(document.file_size) }}</p>
      </div>
      <div>
        <p class="text-sm text-gray-500">File Type</p>
        <p class="font-medium">{{ document.file_extension?.toUpperCase() || 'N/A' }}</p>
      </div>
      <div>
        <p class="text-sm text-gray-500">Category</p>
        <p class="font-medium">{{ document.category_name || 'Uncategorized' }}</p>
      </div>
      <div>
        <p class="text-sm text-gray-500">Uploaded By</p>
        <p class="font-medium">{{ document.uploaded_by_name || 'Unknown' }}</p>
      </div>
    </div>

    <!-- Description -->
    <div *ngIf="document.description">
      <h3 class="font-semibold mb-2">Description</h3>
      <p class="text-gray-700">{{ document.description }}</p>
    </div>

    <!-- Tags -->
    <div *ngIf="document.tags && document.tags.length > 0">
      <h3 class="font-semibold mb-2">Tags</h3>
      <div class="flex flex-wrap gap-2">
        <span
          *ngFor="let tag of document.tags"
          class="px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs"
        >
          {{ tag }}
        </span>
      </div>
    </div>

    <!-- File Preview -->
    <div class="mt-4">
      <h3 class="font-semibold mb-2">Preview</h3>
      <div class="doc-preview__frame border rounded-md bg-white">
        <iframe
          *ngIf="safePreviewUrl && previewKind === 'pdf'"
          [src]="safePreviewUrl"
          class="doc-preview__iframe"
          title="PDF preview"
        ></iframe>

        <img
          *ngIf="safePreviewUrl && previewKind === 'image'"
          [src]="safePreviewUrl"
          class="doc-preview__image"
          [alt]="document.document_name"
        />

        <div *ngIf="loadError" class="doc-preview__message">
          <mat-icon class="text-red-400 text-5xl mb-3">error_outline</mat-icon>
          <p class="text-gray-700">{{ loadError }}</p>
          <button mat-stroked-button color="primary" class="mt-3" (click)="loadDocument()">Retry</button>
        </div>

        <div *ngIf="!loadError && previewKind === 'none'" class="doc-preview__message">
          <mat-icon class="text-gray-400 text-6xl mb-4">insert_drive_file</mat-icon>
          <p class="text-gray-600">Preview not available for this file type</p>
          <p class="text-sm text-gray-500 mt-2">Please download to view</p>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
  <button mat-raised-button color="primary" (click)="download()">
    <mat-icon class="mr-1">download</mat-icon>
    Download
  </button>
</mat-dialog-actions>


